<template>
  <div v-show="showDialog" class="uploadRectBack">
    <div class="uploadRect">
      <div class="titel">上传证书照片</div>
      <div class="IconRect">
        <div class="tools" @click="rotateImg"><i class="iconfont iconrotate" /></div>
        <vueCropper
          ref="cropper"
          class="cutIconRect"
          :img="option.img"
          :output-size="option.size"
          :output-type="option.outputType"
          :info="false"
          :full="option.full"
          :can-move="option.canMove"
          :can-move-box="option.canMoveBox"
          :original="option.original"
          :auto-crop="option.autoCrop"
          :fixed="option.fixed"
          :fixed-number="option.fixedNumber"
          :center-box="option.centerBox"
          :fixed-box="option.fixedBox"
          :max-img-size="option.maxImgSize"
          :enlarge="option.enlarge"
          :auto-crop-width="option.autoCropWidth"
          :auto-crop-height="option.autoCropHeight"
        />
        <van-uploader :after-read="onRead" class="test1">
          <van-button type="primary" style="width:100%;height:3em;" :color="GetColorMain()">选择照片</van-button>
          <div class="about">注意！此次上传的照片，将会替换所有证书的头像，包括下单后还未显示已确认状态的实体潜水卡。</div>
        </van-uploader>
      </div>
      <van-button type="primary" class="downButton" plain @click="onClose">取消</van-button>
      <van-button type="primary" class="downButton" plain :color="GetColorMain()" @click="onConfirm">确定</van-button>
    </div>
  </div>
</template>
<script>
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import { Dialog, Uploader, Button } from 'vant'
import { VueCropper } from 'vue-cropper'
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    VueCropper
  },
  props: {
    value: Boolean
  },
  data() {
    return {
      showDialog: false,
      changeUserHead: false,
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [10, 13], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        maxImgSize: 2000,
        enlarge: 1,
        autoCropWidth: 200,
        autoCropHeight: 260
      }
    }
  },
  watch: {
    value(newValue) {
      this.showDialog = newValue
    }
  },
  created() {

  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onClose() {
      // onUpload
      this.$emit('input', false)
    },
    rotateImg() {
      if (this.option.img === undefined || this.option.img == null || this.option.img === '') {
        return
      }
      this.$refs.cropper.rotateRight()
    },
    onRead(file) {
      this.option.img = file.content
      this.changeUserHead = true
    },
    onConfirm() {
      var height = this.$refs.cropper.cropH
      console.log(height)
      var bl = 260.0 / height
      console.log(bl)
      this.option.enlarge = bl
      this.$refs.cropper.getCropData((data) => {
        this.$emit('input', false)
        this.$emit('change', data)
      })
    }
  }
}
</script>
<style scoped>
.cutIconRect{
    width: 100%;
    height: 20em !important;
}
.tools{
  position: absolute;
  right: 0.5em;
  top:0.5em;
  z-index: 999;
  width: 2em;
  height: 2em;
  line-height: 2em;
  border-radius: 1em;
  text-align: center;
  background-color: #fff;
}
.IconRect{
  overflow: hidden;
  position: relative;
}
.test1{
  width: 100%;
}
.test1 div{
  width: 100%;
}
.uploadRectBack{
   position: fixed;
   left: 0;
   right: 0;
   top: 0;
   bottom: 0;
   background-color:rgba(0, 0, 0, 0.7);
   z-index: 10000;
}
.uploadRect{
  position: fixed;
  left: 1.5em;
  right: 1.5em;
  background-color: #fff;
  top: 2em;
  height: 32.5em;
  z-index: 10001;
  border-radius: 0.4em;
  overflow: hidden;
  border: 1px solid #eaeaea;
}
.uploadRect .titel{
  text-align: center;
  line-height: 3em;
  font-size: 1.1em;
  font-weight: 700;
}
.uploadRect .downButton{
  border-top: 1px solid #eaeaea !important;
  width:50%;
  border-right: none;
  border-left: none;
  border-bottom: none;
  height:3em;
}
.about{
  margin:0.5em 0;
  height: 3em;
  font-size: 0.7em;
  color: #999;
}
</style>
<style>
.van-uploader__input-wrapper{
  width: 100%;
}
</style>
